export const BRIEFING_BOX_EN = {
  briefingheadline: 'Custom Instructions',
  enterbriefing: 'Enter custom instructions details…',
  customInstructionsAreSavedAutomatically: 'Custom instructions are saved automatically',
  briefingPaywallTitle: 'Custom Instructions'
}

export const BRIEFING_BOX_DE = {
  briefingheadline: 'Extra Anweisungen',
  enterbriefing: 'Anweisungsdetails eingeben…',
  customInstructionsAreSavedAutomatically: 'Eingegebene Anweisungen werden automatisch gespeichert',
  briefingPaywallTitle: 'Extra Anweisungen'
}
